var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('z-table',{attrs:{"route":`tradeAccount/${_vm.id}/user`,"editAble":false,"searchAble":true,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }